import { isValidElement } from 'react';
import { isNonNullable, isPlainObject } from './is';
const convertToTooltipProps = (tooltip, context) => {
  if (!isNonNullable(tooltip)) {
    return null;
  }
  if (isPlainObject(tooltip) && ! /*#__PURE__*/isValidElement(tooltip)) {
    return {
      ...context,
      ...tooltip
    };
  }
  return {
    ...context,
    title: tooltip
  };
};
export default convertToTooltipProps;